import { AfterContentInit, Component, Input, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatFooterCellDef, MatFooterCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatFooterRowDef, MatFooterRow } from '@angular/material/table';
import { NgClass, SlicePipe } from '@angular/common';
import { PaginaDatosTablaComponent } from '../pagina-datos-tabla/pagina-datos-tabla.component';

@Component({
    selector: 'app-detalle-tabla-ocupantes-resumen',
    templateUrl: './detalle-tabla-ocupantes-resumen.component.html',
    styleUrls: ['./detalle-tabla-ocupantes-resumen.component.scss'],
    imports: [MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatFooterCellDef, MatFooterCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatFooterRowDef, MatFooterRow, NgClass, PaginaDatosTablaComponent, SlicePipe]
})
export class DetalleTablaOcupantesResumenComponent implements AfterContentInit {
  //Tabla Coberturas terceros
  @ViewChild('asegurado') paginatorA: MatPaginator;
  @ViewChild('tercero') paginatorT: MatPaginator;

  @Input() public datosAsegurados: MatTableDataSource<any> = new MatTableDataSource([]);

  @Input() datosTerceros: MatTableDataSource<any> = new MatTableDataSource([]);

  public tamanoResultadosAsegurado: number = 0;
  public selectCoberturasDatosAsegurado = null;
  public selectedCoberturaRowIndexAsegurado: number = null;

  public tamanoResultadosTercero: number = 0;
  public selectCoberturasDatosTercero = null;
  public selectedCoberturaRowIndexTercero: number = null;

  public displayColumns = ['Estatus', 'Nombre', 'Edad'];

  public paginatorInfo = { pageStart: 0, pageEnd: 0 };
  public paginatorInfoTer = { pageStart: 0, pageEnd: 0 };


  constructor() {

  }

  ngAfterContentInit(): void {
  }

  SelectRow(row, tipo: 'ASEGURADO' | 'TERCEROS') {
    if (tipo === 'ASEGURADO') {
      this.selectCoberturasDatosAsegurado = row.id;
      this.selectedCoberturaRowIndexAsegurado = row;
    } else {
      this.selectedCoberturaRowIndexTercero = row.id;
      this.selectCoberturasDatosTercero = row

    }
  }

}
